import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
// import ReactTooltip from 'react-tooltip'
import Styles from './Badges.css'

@CSSModules(Styles, {allowMultiple:true})
export default class Badges extends Component {
  static propTypes = {
    fund: PropTypes.object.isRequired,
    small: PropTypes.bool,
  }
  constructor(props){
    super(props);
  }
  renderActiveBadges(count, labels){
    return labels.map( (label,idx) =>{
      const isActive = idx < count
      const styleActive = (isActive)?('badge-active'):('badge-inactive')
      const tip = (isActive)?('No '+label+' investments!'):('Has '+label+' investments')

      return(
        <div key={idx}
             styleName={styleActive}
             data-multiline={true}
             data-effect={'solid'}
             data-tip={"<div style='max-width:150px;'>"+tip+'</div>'}
             data-for='badges-tooltip'
             data-place='bottom'
             data-html={true}>
          <i className='fa fa-certificate' />
        </div>
      )
    })
  }
  render() {
    const fund = this.props.fund
    let badgeCount = 0
    const badgeLabelsActive = []
    const badgeLabelsInactive = []
    const labels = {
      'c2':'Carbon Underground 200',
      'co':'coal industry',
      'og':'oil/gas industry',
      'f5':'Macroclimate 50',
      'ut':'fossil-fired utilities',
    }

    Object.keys(labels).forEach((key, idx) => {
      if (fund[key+'count'] === '0') {
        badgeCount += 1
        badgeLabelsActive.push(labels[key])
      } else {
        badgeLabelsInactive.push(labels[key])
      }
    })

    const badgeLabels = badgeLabelsActive.concat(badgeLabelsInactive)

    let badgeStyleName = 'badge-wrap'
    if (this.props.small){ badgeStyleName += '-small' }

    return (
      <div styleName={badgeStyleName}>

        { this.renderActiveBadges(badgeCount, badgeLabels) }

      </div>
    )
  }
}